import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE } from '../api-base.token';
import { WorkspaceInformationResponse } from './workspace-information-response.model';
import { WorkspaceRequest } from './workspace-request.model';
import { WorkspaceResponse } from './workspace-response.model';
import { WorkspaceTextUsageModel } from './workspace-text-usage.model';

const path = 'workspaces';

@Injectable({
  providedIn: 'root',
})
export class WorkspacesHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  get() {
    const url = Location.joinWithSlash(this.apiBase, path);

    return this.httpClient.get<WorkspaceResponse[]>(url);
  }

  getWorkspaceInformation(workspaceId: string) {
    const url = Location.joinWithSlash(
      this.apiBase,
      `${path}/${workspaceId}/information`
    );

    return this.httpClient.get<WorkspaceInformationResponse>(url);
  }

  getWorkspaceInformationWithHeaderWorkspaceId() {
    const url = Location.joinWithSlash(
      this.apiBase,
      `${path}/information`
    );

    return this.httpClient.get<WorkspaceInformationResponse>(url);
  }

  getTextUsage() {
    const url = Location.joinWithSlash(this.apiBase, `${path}/text-usage`);

    return this.httpClient.get<WorkspaceTextUsageModel>(url);
  }

  post(request: WorkspaceRequest) {
    const url = Location.joinWithSlash(this.apiBase, path);

    return this.httpClient.post(url, request);
  }

  put(
    workspaceId: string,
    request: WorkspaceRequest
  ): Observable<WorkspaceResponse> {
    const url = Location.joinWithSlash(this.apiBase, `${path}/${workspaceId}`);

    return this.httpClient.put<WorkspaceResponse>(url, request);
  }

  delete(workspaceId: string) {
    const url = Location.joinWithSlash(this.apiBase, `${path}/${workspaceId}`);

    return this.httpClient.delete(url);
  }

  exists(workspaceCode: string) {
    const url = Location.joinWithSlash(
      this.apiBase,
      `${path}/${workspaceCode}/exists`
    );

    return this.httpClient.get<boolean>(url);
  }

  getWorkspaceId(workspaceCode: string) {
    const url = Location.joinWithSlash(
      this.apiBase,
      `${path}/${workspaceCode}`
    );

    return this.httpClient.get<string>(url);
  }
}
